import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AdminNavbar from '../../components/AdminNavbar';
import EstablishmentLocation from '../../components/EstablishmentLocation';
import EstablishmentHours from '../../components/EstablishmentHours';
import EstablishmentSocialMedia from '../../components/EstablishmentSocialMedia';
import axiosInstance from '../../services/axiosInstance';

// Fonctions utilitaires (gardées identiques)
async function fetchEstablishment(id) {
  try {
   
    const res = await axiosInstance.get(`/establishments/${id}`);
    console.log("res : " , res.data.establishment)
    return res.data.establishment;
    
  } catch (err) {
    console.error('Erreur lors de la récupération de l\'établissement:', err);
    return null;
  }
}

async function updateEstablishment(partnerUserId, establishment) {
  try {
    const res = await axiosInstance.patch(`/partner_users/${partnerUserId}/establishments/${establishment.id}`, establishment);
    console.log("chargement" , res.data.establishment )
    return res.data.establishment;
  } catch (err) {
    console.error(err);
    return null;
  }
}

function AdminPage() {
  const { id_etablissement } = useParams();
  const [establishment, setEstablishment] = useState(null);
  const navigate = useNavigate();
  const [photos, setPhotos] = useState([]);
  const [previewPhotos, setPreviewPhotos] = useState([]);
  const partnerUserId = localStorage.getItem('user_id');
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [currentPhotoId, setCurrentPhotoId] = useState(null);
  const [newPhotoFile, setNewPhotoFile] = useState(null);
  const fileInput = useRef(null);
  const [offeredDrinks, setOfferedDrinks] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  // Styles intégrés
  const styles = {
    container: {
      backgroundColor: '#f8fafc',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },
    backButton: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '8px 16px',
      backgroundColor: '#ffffff',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      color: '#374151',
      textDecoration: 'none',
      fontSize: '14px',
      fontWeight: '500',
      margin: '20px',
      cursor: 'pointer',
      transition: 'all 0.15s ease-in-out'
    },
    section: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      margin: '20px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      border: '1px solid #e2e8f0'
    },
    sectionTitle: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#1e293b',
      marginBottom: '16px'
    },
    input: {
      width: '100%',
      padding: '12px 16px',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      fontSize: '16px',
      transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
      outline: 'none',
      backgroundColor: '#ffffff',
      boxSizing: 'border-box'
    },
    button: {
      padding: '12px 24px',
      backgroundColor: '#059669',
      color: '#ffffff',
      border: 'none',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'background-color 0.15s ease-in-out',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px'
    },
    buttonSecondary: {
      backgroundColor: '#6b7280',
      color: '#ffffff'
    },
    buttonDanger: {
      backgroundColor: '#dc2626',
      color: '#ffffff'
    },
    toggleSection: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '20px',
      backgroundColor: '#f0f9ff',
      border: '1px solid #0ea5e9',
      borderRadius: '12px',
      margin: '20px'
    },
    switch: {
      position: 'relative',
      display: 'inline-block',
      width: '60px',
      height: '34px'
    },
    switchInput: {
      opacity: 0,
      width: 0,
      height: 0
    },
    slider: {
      position: 'absolute',
      cursor: 'pointer',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#ccc',
      transition: '.4s',
      borderRadius: '34px'
    },
    sliderChecked: {
      backgroundColor: '#059669'
    },
    sliderBefore: {
      position: 'absolute',
      content: '""',
      height: '26px',
      width: '26px',
      left: '4px',
      bottom: '4px',
      backgroundColor: 'white',
      transition: '.4s',
      borderRadius: '50%'
    },
    photoGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '20px',
      padding: '20px'
    },
    photoCard: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0'
    },
    photoImage: {
      width: '100%',
      height: '200px',
      objectFit: 'cover'
    },
    photoActions: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '12px'
    },
    iconButton: {
      padding: '8px',
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      transition: 'background-color 0.15s ease-in-out'
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    },
    modalContent: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      width: '100%',
      maxWidth: '500px',
      margin: '20px'
    },
    uploadArea: {
      border: '2px dashed #d1d5db',
      borderRadius: '12px',
      padding: '40px 20px',
      textAlign: 'center',
      backgroundColor: '#f9fafb',
      cursor: 'pointer',
      transition: 'border-color 0.15s ease-in-out'
    }
  };

  // Fonctions de gestion (gardées identiques mais simplifiées)
  const handleUploadPhotos = async () => {
    const files = fileInput.current.files;
    if (files.length === 0) return;

    setIsUploading(true);
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i]);
    }

    try {
      await axiosInstance({
        method: 'post',
        url: `/etablissement/${id_etablissement}/photos`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setPreviewPhotos([]);
      // Recharger les photos
      const response = await axiosInstance.get(`/etablissement/${id_etablissement}/photos`);
      setPhotos(response.data);
    } catch (error) {
      console.error('Error adding data: ', error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    const photosArray = [];

    for (let i = 0; i < files.length; i++) {
      const reader = new FileReader();
      reader.onload = (e) => {
        photosArray.push(e.target.result);
        if (photosArray.length === files.length) {
          setPreviewPhotos(photosArray);
        }
      };
      reader.readAsDataURL(files[i]);
    }
  };

  const handleDeletePhoto = async (photoId) => {
    try {
      await axiosInstance.delete(`/etablissement/${id_etablissement}/photos/${photoId}`);
      setPhotos(prevPhotos => prevPhotos.filter(photo => photo.id !== photoId));
    } catch (error) {
      console.error("Error deleting photo:", error);
    }
  };

  const toggleVisibility = async () => {
    try {
      const response = await axiosInstance.put(`/update-visibility_establishment/${establishment.id}`, {
        visible: !establishment.visible
      });

      if (response.status === 200) {
        setEstablishment(prevEstablishment => ({
          ...prevEstablishment,
          visible: !prevEstablishment.visible
        }));
      }
    } catch (error) {
      console.error('Erreur lors de la modification de la visibilité', error);
    }
  };

  const handleToggleCloche = (checked) => {
    const updatedEstablishment = { ...establishment, la_cloche: checked };
    setEstablishment(updatedEstablishment);
    updateEstablishment(partnerUserId, updatedEstablishment);
  };

  const handleNameChange = newName => {
    const updatedEstablishment = { ...establishment, name: newName };
    setEstablishment(updatedEstablishment);
    updateEstablishment(partnerUserId, updatedEstablishment);
  };

  const handleDescriptionChange = newDescription => {
    const updatedEstablishment = { ...establishment, description: newDescription };
    setEstablishment(updatedEstablishment);
    updateEstablishment(partnerUserId, updatedEstablishment);
  };

  const handleOfferedDrinksChange = (newOfferedDrinks) => {
    const updatedEstablishment = { ...establishment, number_of_offered_products: newOfferedDrinks };
    setEstablishment(updatedEstablishment);
    setOfferedDrinks(newOfferedDrinks);
    updateEstablishment(partnerUserId, updatedEstablishment);
  };

  // useEffect modifié - SUPPRESSION DE LA VÉRIFICATION D'ACCÈS
  useEffect(() => {
    const fetchAndSetEstablishment = async () => {
      console.log('Chargement de l\'établissement:', id_etablissement);
      const establishmentData = await fetchEstablishment(id_etablissement);
      if (establishmentData) {
        console.log('Établissement chargé:', establishmentData);
        setEstablishment(establishmentData);
        setOfferedDrinks(establishmentData.number_of_offered_products || 0);
      } else {
        console.error('Impossible de charger l\'établissement');
        // Ne pas rediriger, laisser ProtectedRoute2 gérer l'accès
      }
    };

    fetchAndSetEstablishment();

    // Charger les photos
    axiosInstance.get(`/etablissement/${id_etablissement}/photos`)
      .then(response => {
        setPhotos(response.data);
      })
      .catch(error => {
        console.error("Error fetching photos:", error);
      });
  }, [id_etablissement]);

  if (!establishment) {
    return (
      <div style={styles.container}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '40px',
              height: '40px',
              border: '4px solid #e5e7eb',
              borderTop: '4px solid #059669',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 16px'
            }}></div>
            <p style={{ color: '#6b7280' }}>Chargement de l'établissement...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <AdminNavbar establishmentId={id_etablissement} name={establishment.name} />

      {/* Bouton retour */}
      <button
        onClick={() => navigate('/accueil')}
        style={styles.backButton}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
        onMouseLeave={(e) => e.target.style.backgroundColor = '#ffffff'}
      >
        ← Retour à l'accueil
      </button>

      {/* Section visibilité */}
      <div style={styles.toggleSection}>
        <div>
          <h3 style={{ margin: '0 0 4px 0', fontSize: '18px', fontWeight: '600', color: '#0f172a' }}>
            Visibilité de l'établissement
          </h3>
          <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>
            {establishment.visible ? 'Votre établissement est visible par les utilisateurs' : 'Votre établissement est masqué'}
          </p>
        </div>
        <button
          onClick={toggleVisibility}
          style={{
            ...styles.button,
            ...(establishment.visible ? styles.buttonDanger : {})
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = establishment.visible ? '#b91c1c' : '#047857';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = establishment.visible ? '#dc2626' : '#059669';
          }}
        >
          {establishment.visible ? 'Masquer' : 'Rendre visible'}
        </button>
      </div>

      {/* Section Cloche */}
      <div style={styles.toggleSection}>
        <div>
          <h3 style={{ margin: '0 0 4px 0', fontSize: '18px', fontWeight: '600', color: '#0f172a' }}>
            Fait-il partie de la cloche ?
          </h3>
          <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>
            Indiquez si l'établissement fait partie de la cloche
          </p>
        </div>
        <label style={styles.switch}>
          <input
            type="checkbox"
            checked={establishment?.la_cloche || false}
            onChange={(e) => handleToggleCloche(e.target.checked)}
            style={styles.switchInput}
          />
          <span style={{
            ...styles.slider,
            ...(establishment?.la_cloche ? styles.sliderChecked : {})
          }}>
            <span style={{
              ...styles.sliderBefore,
              transform: establishment?.la_cloche ? 'translateX(26px)' : 'translateX(0)'
            }}></span>
          </span>
        </label>
      </div>

      {/* Informations de base */}
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Informations de l'établissement</h2>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
            Nom de l'établissement
          </label>
          <input
            type="text"
            value={establishment.name}
            onChange={(e) => handleNameChange(e.target.value)}
            style={styles.input}
            onFocus={(e) => {
              e.target.style.borderColor = '#059669';
              e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
            Description
          </label>
          <textarea
            value={establishment.description}
            onChange={(e) => handleDescriptionChange(e.target.value)}
            rows="4"
            style={{
              ...styles.input,
              resize: 'vertical',
              minHeight: '100px'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#059669';
              e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
            Nombre de boissons offertes par utilisateur
          </label>
          <input
            type="number"
            value={offeredDrinks}
            onChange={(e) => handleOfferedDrinksChange(e.target.value)}
            style={styles.input}
            onFocus={(e) => {
              e.target.style.borderColor = '#059669';
              e.target.style.boxShadow = '0 0 0 3px rgba(5, 150, 105, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
      </div>
 
      {/* Section Photos */}
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Gestion des photos</h2>
        
        <div style={{ marginBottom: '20px' }}>
          <div
            style={styles.uploadArea}
            onClick={() => fileInput.current?.click()}
            onMouseEnter={(e) => e.target.style.borderColor = '#059669'}
            onMouseLeave={(e) => e.target.style.borderColor = '#d1d5db'}
          >
            <input
              ref={fileInput}
              type="file"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>📸</div>
            <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '500', color: '#374151' }}>
              Cliquez pour sélectionner des photos
            </p>
            <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
              Formats acceptés: JPG, PNG, GIF
            </p>
          </div>
 
          {previewPhotos.length > 0 && (
            <div style={{ marginTop: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '500' }}>Prévisualisation</h3>
                <button
                  onClick={handleUploadPhotos}
                  disabled={isUploading}
                  style={{
                    ...styles.button,
                    backgroundColor: isUploading ? '#9ca3af' : '#059669'
                  }}
                >
                  {isUploading ? 'Téléchargement...' : 'Valider les photos'}
                </button>
              </div>
              <div style={styles.photoGrid}>
                {previewPhotos.map((photoURL, index) => (
                  <div key={index} style={styles.photoCard}>
                    <img src={photoURL} alt="Prévisualisation" style={styles.photoImage} />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
 
      {/* Photos existantes */}
      {photos.length > 0 && (
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Photos de l'établissement</h2>
          <div style={styles.photoGrid}>
            {photos.map(photo => (
              <div key={photo.id} style={styles.photoCard}>
                <img
                  src={`https://backend.csibon.app/photos/${photo.photo_url}`}
                  alt="Photo de l'établissement"
                  style={styles.photoImage}
                />
                <div style={styles.photoActions}>
                  <button
                    onClick={() => handleDeletePhoto(photo.id)}
                    style={{
                      ...styles.iconButton,
                      color: '#dc2626'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#fee2e2'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    🗑️ Supprimer
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
 
      {/* Composants existants */}
      <div style={styles.section}>
        <EstablishmentHours
          initialHours={establishment.horaire ? JSON.parse(establishment.horaire) : {}}
          onHoursChange={(newHours) => {
            const updatedEstablishment = { ...establishment, horaire: JSON.stringify(newHours) };
            setEstablishment(updatedEstablishment);
            updateEstablishment(partnerUserId, updatedEstablishment);
          }}
        />
      </div>
 
      <div style={styles.section}>
        <EstablishmentSocialMedia
          socialMedia={establishment.socialMedia || {}}
          onSocialMediaChange={(newSocialMedia) => {
            const updatedEstablishment = { ...establishment, socialMedia: newSocialMedia };
            setEstablishment(updatedEstablishment);
            updateEstablishment(partnerUserId, updatedEstablishment);
          }}
        />
      </div>
 
      <div style={styles.section}>
        <EstablishmentLocation
          location={{ lat: establishment.lat, lon: establishment.lon }}
          onLocationChange={(newLocation) => {
            const updatedEstablishment = { ...establishment, lat: newLocation.lat, lon: newLocation.lon };
            setEstablishment(updatedEstablishment);
            updateEstablishment(partnerUserId, updatedEstablishment);
          }}
        />
      </div>
 
      {/* CSS pour les animations */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
 }
 
 export default AdminPage;